export default __webpack_public_path__ + "images/walmart_iamge2.svg";